 <template>
  <f7-page no-toolbar no-swipeback  class="vip-list" @page:init="onPageInit" style="padding-bottom: var(--f7-safe-area-bottom);">
    <f7-navbar innerClass="navbar-inner-message">
      <f7-nav-left>
        <f7-link @click="$f7router.back()">
          <i class="f7-icons">chevron_left</i>
        </f7-link>
      </f7-nav-left>
      <f7-nav-title>VIP</f7-nav-title>
    </f7-navbar>

    <div class="content">

      <div style="background: #99bfa8;padding: 10px 10px 1px 10px;margin-bottom: 10px;border-radius: 7px;">
        <div class="all" v-for="(item, index) in filterVipList1" :key="index+'a'" >
          <img v-if="item.EnableVIPLevelUpdate"  src="../../../static/images/yt999/vip/vipbg1.png" width="100%">
          <!-- <img v-else src="../../../static/images/yt999/vip/vipbg1_1.png" width="100%"> -->
          <img v-else src="../../../static/images/yt999/vip/vipbg1.png" width="100%">
          <div class="txt">
            <div class="name" v-if="item.Name.length<10">{{ item.Name }}</div>
            <div class="name" v-else style="font-size: 18px;">{{ item.Name }}</div>
            <div class="btn">
              <span v-if="item.EnableVIPLevelUpdate||item.Name == 'Pasantes'" @click="$f7router.navigate('/member-center/vip/' + item.Id + '/')" style="position: relative;">
                <img v-show="item.Id==userInfo.VipLevel" src="../../../static/images/yt999/vip/me.png" height="18" style="position: absolute;right: 5px;top: 0px;">
                <span>{{ $t("vip_list_001") }}</span>
              </span>
              <span v-else style="background: #ccc;">
                {{ $t("vip_list_002") }}
              </span>
              
            </div>
          </div>
        </div>
      </div>

      <div style="background: #b4defb;padding: 10px 10px 1px 10px;margin-bottom: 10px;border-radius: 7px;">
        <div class="all" v-for="(item, index) in filterVipList2" :key="index+'b'">
          <img  v-if="item.EnableVIPLevelUpdate" src="../../../static/images/yt999/vip/vipbg2.png" width="100%">
          <img  v-else src="../../../static/images/yt999/vip/vipbg2.png" width="100%">
          <div class="txt">
            <div class="name">{{ item.Name }}</div>
            <div class="btn">
              <span v-if="item.EnableVIPLevelUpdate"  @click="$f7router.navigate('/member-center/vip/' + item.Id + '/')" style="position: relative;">
                <img v-show="item.Id==userInfo.VipLevel" src="../../../static/images/yt999/vip/me.png" height="18" style="position: absolute;right: 5px;top: 0px;">
                <span>{{ $t("vip_list_001") }}</span>
              </span>
              <span v-else style="background: #ccc;">
                {{ $t("vip_list_002") }}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div style="background: #d4d5a6;padding: 10px 10px 1px 10px;margin-bottom: 10px;border-radius: 7px;">
        <div class="all" v-for="(item, index) in filterVipList3" :key="index+'b'">
          <img  v-if="item.EnableVIPLevelUpdate" src="../../../static/images/yt999/vip/vipbg3.png" width="100%">
          <img  v-else src="../../../static/images/yt999/vip/vipbg3.png" width="100%">
          <div class="txt">
            <div class="name">{{ item.Name }}</div>
            <div class="btn">
              <span v-if="item.EnableVIPLevelUpdate"  @click="$f7router.navigate('/member-center/vip/' + item.Id + '/')" style="position: relative;">
                <img v-show="item.Id==userInfo.VipLevel" src="../../../static/images/yt999/vip/me.png" height="18" style="position: absolute;right: 5px;top: 0px;">
                <span>{{ $t("vip_list_001") }}</span>
              </span>
              <span v-else style="background: #ccc;">
                {{ $t("vip_list_002") }}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div style="background: rgb(167, 166, 213);padding: 10px 10px 1px 10px;margin-bottom: 10px;border-radius: 7px;">
        <div class="all" v-for="(item, index) in filterVipList4" :key="index+'b'">
          <img  v-if="item.EnableVIPLevelUpdate" src="../../../static/images/yt999/vip/vipbg3.png" width="100%">
          <img  v-else src="../../../static/images/yt999/vip/vipbg3.png" width="100%">
          <div class="txt">
            <div class="name">{{ item.Name }}</div>
            <div class="btn">
              <span v-if="item.EnableVIPLevelUpdate"  @click="$f7router.navigate('/member-center/vip/' + item.Id + '/')" style="position: relative;">
                <img v-show="item.Id==userInfo.VipLevel" src="../../../static/images/yt999/vip/me.png" height="18" style="position: absolute;right: 5px;top: 0px;">
                <span>{{ $t("vip_list_001") }}</span>
              </span>
              <span v-else style="background: #ccc;">
                {{ $t("vip_list_002") }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>   
  </f7-page>
</template>

<script>
import { getCookie,getStore } from "@/config/utils";
import { getsimpleviplist } from "../../../axios/api";
import { mapGetters, mapMutations, mapActions } from "vuex";
export default {
  components: {},
  props: {},
  data() {
    const self = this;
    return {
      currencySymbol: '',
      simpleVipList: [],
      
    };
  },
  watch: {
    // 滑动
    checkIndex(newData, oldData) {
      this.updateAm(this.checkIndex);
      this.$refs.mySwiper.swiper.slideTo(this.checkIndex, 1000);   // mySwiper对象名是通过 ref定义的
    }

  },
  computed: {
    ...mapGetters(["userInfo", "getLoginInfo", "getLoginState"]),
    filterVipList1() {
      return this.simpleVipList.filter(item => item.Remark === '1')
    },
    filterVipList2() {
      return this.simpleVipList.filter(item => item.Remark === '2')
    },
    filterVipList3() {
      return this.simpleVipList.filter(item => item.Remark === '3')
    },
    filterVipList4() {
      return this.simpleVipList.filter(item => item.Remark === '4')
    },
  },
  methods: {
    ...mapActions(["saveLoginState", "getUserInfo"]),
    onPageInit(){

    },

    getSimpleVipList() {
      const self = this;
      const vipLevel = this.$f7route.params.vipLevel;
      const params = {"ShowDefault":true};
      let d = JSON.stringify(params);
      getsimpleviplist(d).then((data) => {
        if (data.Code === "NoError") {
          self.simpleVipList = data.Data;
        }
      });
    },
  },
  created() {
    this.currencySymbol = getStore('currencySymbol');
    this.$f7.emit("myCustomEvent", "vip-list");
    this.getSimpleVipList();
    this.getUserInfo();
  },
  mounted() {
  },
};
</script>
<style lang="less" scoped>
.content{
  padding: 10px;
  .all{
    width: 100%;
    position: relative;
    margin-bottom: 7px;

    .txt{
      width: 60%;
      position: absolute;
      right: 0;
      top: 0;
      display: grid;
      align-items: center;
      margin-top: 22px;
      .name{
        font-size: 22px;
        font-weight: bold;
        color: var(--f7-THEME-color);
      }
      .btn{
        span:first-child{
          background: var(--f7-THEME-color);
          color: white;
          padding: 3px 22px;
          border-radius: 5px;
          min-width: 90px;
          display: inline-block;
          text-align: center;
        }
        .no{
          background: #ccc;

        }
      }
    }
  }


}
</style>
